import { Text } from '@adc/parallax-component-library';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useAdminUser } from '~/api/query/adminUserGet';
import { AdminEditUserModal } from '~/components/modals/AdminEditUserModal';
import { USER_ROLES } from '~/features/auth/roles';
import { Route as UserAdministrationRoute } from '~/routes/hcp-admin/users';
import { protectedRoute } from '~/utils/routesAuthorization';

const TEST_ID = 'user-details';

export const Route = createFileRoute('/hcp-admin/users/$userId')({
  component: EditUserRoute,
  params: {
    parse: (params) => ({ userId: Number.parseInt(params.userId) }),
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.HcpAdmin, USER_ROLES.NonHcpAdmin],
    });
  },
});

function EditUserRoute() {
  const { userId } = Route.useParams();
  const navigate = useNavigate({ from: Route.fullPath });

  const { data, isLoading, error } = useAdminUser(userId);

  if (!data && !isLoading) {
    void navigate({ to: UserAdministrationRoute.fullPath });

    return null;
  }

  if (error) {
    // TODO: Improve error handling
    return <Text>Error {error.message}</Text>;
  }

  return (
    <AdminEditUserModal
      testID={TEST_ID}
      isLoading={isLoading}
      user={data}
      onCloseRedirectPath={Route.fullPath}
    />
  );
}
